import { CountUp } from 'countup.js';

export default function initCounter() {
  const counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;

  const defaultOptions = {
    duration: 2,
    separator: '.',
    decimalPlaces: 1,
    suffix: '%',
  };

  const optionsK = {
    duration: 2,
    separator: '',
    suffix: 'k+',
    decimalPlaces: 0,
  };

  const optionsless = {
    duration: 2,
    separator: '',
    suffix: '%',
    decimalPlaces: 0,
  };

  const startCounterAnimation = (counter) => {
    const value = parseFloat(counter.dataset.counter);
    let options = defaultOptions;

    if (counter.classList.contains('counter-k')) {
      options = optionsK;
    }
    
    if (counter.classList.contains('less')) {
      options = optionsless;
    }

    if (isNaN(value)) {
      console.error(`Invalid counter value for element: ${counter}`);
      return;
    }

    const countUpAnimation = new CountUp(counter, value, options);
    if (countUpAnimation.error) {
      console.error('Error initializing CountUp animation:', countUpAnimation.error);
      return;
    }

    countUpAnimation.start();
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startCounterAnimation(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach((counter) => observer.observe(counter));
}
